import React, { useEffect } from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

const DownloadPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <section className="flex-grow flex items-center bg-white pt-20 min-h-screen md:pt-0">
        <div className="container mx-auto px-6 md:px-4 py-8 md:py-16">
          <div className="flex flex-col md:flex-row items-center justify-center md:space-x-4">
            {/* Image Section */}
            <div className="w-48 md:w-64 mb-8 md:mb-0">
              <img 
                src="logoctc2.png"
                alt="Game Logo" 
                className="w-full h-auto border-r-4 border-b-4 border-black"
              />
            </div>

            {/* Text and Button Section */}
            <div className="max-w-lg text-center md:text-left">
              <h1 className="text-5xl md:text-6xl font-medium text-gray-800 mb-2 font-trends">
                Download Soon!
                <p className="text-xl md:text-2xl font-medium text-gray-800 font-trends mt-2">
                  Chase the Chickens
                </p>
              </h1>
              <p className="text-lg md:text-xl text-gray-600 mt-4 mb-8 md:mb-6 px-4 md:px-0">
                Get ready for the ultimate chicken-chasing adventure! Available soon on your favourite platform.
              </p>
              <div className="flex flex-col md:flex-row items-center justify-center md:justify-start space-y-4 md:space-y-0 md:space-x-4">
                {/* App Store Button */}
                <a
                  href="https://www.apple.com/app-store/"
                  className="w-64 md:w-auto bg-[#E57373] hover:bg-[#EF9A9A] text-white rounded-full px-8 py-3 text-base md:text-lg flex items-center justify-center space-x-3 shadow-lg transform hover:scale-105 transition-transform duration-200"
                >
                  <FaApple className="w-5 md:w-6 h-5 md:h-6" />
                  <span>App Store</span>
                </a>

                {/* Google Play Button */}
                <a
                  href="https://play.google.com"
                  className="w-64 md:w-auto bg-gray-800 hover:bg-gray-700 text-white rounded-full px-8 py-3 text-base md:text-lg flex items-center justify-center space-x-3 shadow-lg transform hover:scale-105 transition-transform duration-200"
                >
                  <FaGooglePlay className="w-5 md:w-6 h-5 md:h-6" />
                  <span>Google Play</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default DownloadPage;